import { useState } from "react";
import { FiZap, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { AIInputSection } from "../../../avaliations/AIInputSection";

interface AISectionProps {
  aiInputValue: string;
  onInputChange: (value: string) => void;
  onAnalyze: (text?: string) => void;
  onAudioAnalyze: (audioBlob: Blob) => void;
  onImageAnalyze: (imageFile: File) => void;
  placeholder: string;
  disabled: boolean;
  loading: boolean;
}

export const AISection = ({
  aiInputValue,
  onInputChange,
  onAnalyze,
  onAudioAnalyze,
  onImageAnalyze,
  placeholder,
  disabled,
  loading,
}: AISectionProps) => {
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <div className="rounded-xl border border-stroke bg-gradient-to-br from-purple-50 to-purple-50/50 p-3 shadow-sm dark:border-strokedark dark:from-purple-950/20 dark:to-purple-950/10 sm:rounded-xl sm:p-4 md:rounded-2xl md:p-6">
      <button
        type="button"
        onClick={() => setIsMinimized(!isMinimized)}
        className="w-full min-h-[44px] mb-3 flex items-center gap-2 text-left transition-all active:opacity-80 touch-manipulation sm:min-h-0 sm:mb-3.5 sm:gap-2.5 md:mb-4 md:gap-3"
      >
        <div className="rounded-lg bg-gradient-to-br from-purple-600 to-purple-600 p-1.5 text-white shadow-sm flex-shrink-0 sm:p-2 md:rounded-xl md:p-2.5">
          <FiZap size={16} className="sm:w-[18px] sm:h-[18px] md:w-5 md:h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h4 className="text-sm font-bold text-gray-900 dark:text-white sm:text-base md:text-lg">
            Criar Treino com IA
          </h4>
          <p className="text-xs text-gray-600 dark:text-gray-400 line-clamp-2 sm:text-xs">
            Descreva o treino e a IA criará um plano completo usando exercícios
            da base
          </p>
        </div>
        <div className="flex-shrink-0 text-gray-400 dark:text-gray-500">
          {isMinimized ? (
            <FiChevronDown size={20} className="sm:w-5 sm:h-5" />
          ) : (
            <FiChevronUp size={20} className="sm:w-5 sm:h-5" />
          )}
        </div>
      </button>
      {!isMinimized && (
        <div className="animate-in fade-in slide-in-from-top-2 duration-200">
          <p className="mb-3 text-xs font-medium text-gray-600 dark:text-gray-400 sm:text-sm">
            Dica: inclua objetivo, frequência semanal e grupos musculares para
            obter um plano mais preciso.
          </p>
          <AIInputSection
            value={aiInputValue}
            onChange={onInputChange}
            onAnalyze={onAnalyze}
            onAudioAnalyze={onAudioAnalyze}
            onImageAnalyze={onImageAnalyze}
            placeholder={placeholder}
            disabled={disabled}
            loading={loading}
            removeDescription={true}
          />
        </div>
      )}
    </div>
  );
};
